module.exports = "/images/vendor/flag-icon-css/flags/4x3/va.svg?21913d789a3d4b70ce0a72e2ceeea239";